<template>
  <ul class="flex flex-col">
    <template v-for="item in items" :key="item.path">
      <o-menu-item :item="item" />
    </template>
  </ul>
</template>

<script setup lang="ts">
import OMenuItem from './MenuItem.vue'

interface Props {
  items: any[] | Record<string, any>
}

defineProps<Props>()
</script>
